import { render } from "./SegmentDropdown.vue?vue&type=template&id=7962f320&scoped=true"
import script from "./SegmentDropdown.vue?vue&type=script&lang=ts"
export * from "./SegmentDropdown.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7962f320"

export default script